module.exports = __webpack_public_path__ + "static/media/qc-bg.781ae468.jpg";